module.exports = __webpack_public_path__ + "img/new-02-thumbfly2.7a68a823.jpg";